<script>
import modalUploadImage from "../modals/modal-upload-image";

export default {
  name: "watermarkImage",
  components: {
    modalUploadImage,
  },
  data() {
    return {
      watermarkUrl: "",
    };
  },
  computed: {
    curLogo: function () {
      return this.$A.CurLogo();
    },
    hasCustomWatermark: function () {
      return !!this.watermarkUrl;
    },
    // What actually gets stamped when there is no custom watermark.
    previewImage: function () {
      return this.hasCustomWatermark ? this.watermarkUrl : this.curLogo;
    },
  },
  methods: {
    showUploadImageModal: function () {
      this.$refs.uploadImageModal.openModal();
    },
    removeWatermark: async function () {
      const removed = await this.$A.AccountService.RemoveWatermarkImage();
      if (removed) {
        this.watermarkUrl = "";
      }
    },
  },
  async mounted() {
    let self = this;
    this.watermarkUrl = (await this.$A.AccountService.GetWatermarkImage()) || "";
    this.$root.$on("account::watermark::updated", function (url) {
      self.watermarkUrl = url || "";
    });
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Proof Watermark</div>
      <div class="card-head-subtitle">
        Upload a custom image to stamp on watermarked proofs. If none is set, your account logo is used.
      </div>
    </div>
    <div class="card-body watermark-body">
      <button
          type="button"
          class="watermark-tile"
          :title="hasCustomWatermark ? 'Change watermark' : 'Add a watermark'"
          @click="showUploadImageModal"
      >
        <span class="watermark-image" :style="{ backgroundImage: 'url(' + previewImage + ')' }"></span>
        <span class="watermark-overlay">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
            <circle cx="12" cy="13" r="4" />
          </svg>
          {{ hasCustomWatermark ? "Change" : "Upload" }}
        </span>
      </button>
      <div class="watermark-note">
        {{ hasCustomWatermark ? "Using your custom watermark." : "No custom watermark — your account logo is used." }}
      </div>
    </div>
    <div class="card-foot">
      <a
          v-show="hasCustomWatermark"
          class="secondary-btn"
          @click="removeWatermark">Remove</a>
      <a
          class="primary-btn"
          @click="showUploadImageModal">{{ hasCustomWatermark ? "Change Watermark" : "Upload Watermark" }}</a>
    </div>

    <modalUploadImage type="watermark" ref="uploadImageModal"/>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}

.watermark-body {
  align-items: flex-start;
}
.watermark-tile {
  position: relative;
  width: 220px;
  height: 160px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  background: #fff;
  padding: 12px;
  cursor: pointer;
  overflow: hidden;
}
.watermark-image {
  display: block;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.watermark-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: rgba(17, 24, 39, 0.45);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  opacity: 0;
  transition: opacity 120ms ease;
}
.watermark-tile:hover .watermark-overlay {
  opacity: 1;
}
.watermark-note {
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}

.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.secondary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  background: #fff;
  color: #1f2937;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: border-color 120ms ease, color 120ms ease;
}
.secondary-btn:hover {
  border-color: #019256;
  color: #019256;
  text-decoration: none;
}

@media (max-width: 575px) {
  .watermark-tile {
    width: 100%;
  }
  .primary-btn,
  .secondary-btn {
    flex: 1;
  }
}
</style>
